import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL_AMAZINGE_NEW = process.env.REACT_APP_AMAZINGE_API_CONNECT

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL_AMAZINGE_NEW}/`,
  }),

  tagTypes: ['Product'],
  keepUnusedDataFor: 86400000,
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: (data) => {
        return {
          url: `api/products/${data.id}?variant=${data.variant}&country=${data.country}`,
          method: 'GET',
          headers: {
            'X-Country-Code': data.countryCode,
            'X-Store-Id': data.store_id,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Product'],
    }),

    getVarProduct: builder.query({
      query: (data) => {
        return {
          url: `api/products/variants/${data.id}?variant=${data.variant}`,
          method: 'GET',
          headers: {
            'X-Country-Code': data.countryCode,
            'X-Store-Id': data.store_id,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Product'],
    }),

    similarProduct: builder.query({
      query: (data) => {
        return {
          url: `api/product/similar/${data.id}?name=${data.title}`,
          method: 'GET',
          headers: {
            'X-Country-Code': data.countryCode,
            'X-Store-Id': data.store_id,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Product'],
    }),

  }),

})

export const { useGetProductQuery, useGetVarProductQuery, useSimilarProductQuery } = productApi